import { PROVIDER } from "../constants/v2/Constants";

const NON_TERMINAL_PROVIDERS = [
    PROVIDER.CDS,
    PROVIDER.APPLE,
    PROVIDER.GOOGLE,
    PROVIDER.ZUORA
];

const ALL_VALID_PROVIDERS = NON_TERMINAL_PROVIDERS.concat(PROVIDER.TERMINAL);

export function isAppleProvider(provider?: null | string): boolean {
    return provider === PROVIDER.APPLE;
}

export function isTerminalProvider(provider?: null | PROVIDER): boolean {
    return provider === PROVIDER.TERMINAL;
}

export function isNonTerminalProvider(provider?: null | PROVIDER): boolean {
    if (!provider) {
        return false;
    }

    return NON_TERMINAL_PROVIDERS.includes(provider);
}

export function hasValidSubscriptionWith(provider?: null | PROVIDER): boolean {
    if (!provider) {
        return false;
    }

    return ALL_VALID_PROVIDERS.includes(provider);
}

export default {
    isAppleProvider,
    isTerminalProvider,
    isNonTerminalProvider,
    hasValidSubscriptionWith
};
